import { render, staticRenderFns } from "./TendenciasCM.vue?vue&type=template&id=72e1a7aa&"
import script from "./TendenciasCM.vue?vue&type=script&lang=js&"
export * from "./TendenciasCM.vue?vue&type=script&lang=js&"
import style0 from "./TendenciasCM.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports